"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getProductListHybridModeConfig = void 0;
var _constants = require("../../../../constants");
const getProductListHybridModeConfig = (offerId)=>({
        threshold: _constants.MAX_OFFER_CAROUSEL_ITEMS_COUNT + 1,
        type: 'HYBRID',
        carousel: {
            id: "offer-".concat(offerId, "-carousel"),
            slider: {
                breakpoints: {
                    ["(max-width: 740px)"]: {
                        slides: {
                            perView: 2,
                            spacing: 15
                        }
                    },
                    ["(min-width: 740px)"]: {
                        slides: {
                            perView: 3,
                            spacing: 15
                        }
                    }
                },
                slides: {
                    perView: 'auto',
                    spacing: 15
                }
            }
        }
    });
exports.getProductListHybridModeConfig = getProductListHybridModeConfig;
